import { useEffect, useState } from 'react';
import { syntheticEntryQuery } from '../../shared/content-media/content-media';
import type { ReviewCaseView } from '../../shared/product-review/adapters/product-review-port';
import { useSynLive } from '../../shared/product-review/session/ProductReviewSession';
/** Only existing scoped read APIs supply figures. Missing aggregate APIs never become fixtures. */
export function AdminWorkbench() {
  const live = useSynLive();
  const base = '/demo/governance-review';
  const [result, setResult] = useState<{
    session: string;
    rows: readonly ReviewCaseView[] | null;
    error: string;
  } | null>(null);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let current = true;
    if (live.auth && live.port) {
      const session = live.auth.session;
      void live.port
        .listCases({ session })
        .then((outcome) => {
          if (current)
            setResult({
              session,
              rows: outcome.kind === 'OK' ? outcome.value : null,
              error: outcome.kind === 'OK' ? '' : `工作台读取未成功：${outcome.kind}`,
            });
        })
        .catch(() => {
          if (current) setResult({ session, rows: null, error: '工作台服务不可用，请重试' });
        });
    }
    return () => {
      current = false;
    };
  }, [live.auth, live.port, false, refresh]);
  const rows = result?.session === live.session ? result.rows : null;
  const link = (suffix: string) => base + suffix + syntheticEntryQuery();
  const adminCards = [
    ['当前审核事项', rows?.length ?? '—', '/queue'],
    ['待处理', rows?.filter((row) => !row.decision).length ?? '—', '/queue'],
    [
      '产品资料',
      rows?.filter((row) => row.submitted.subjectKind === 'PRODUCT_MODEL').length ?? '—',
      '/products',
    ],
    [
      '装备资料',
      rows?.filter((row) => row.submitted.subjectKind === 'LOCAL_ASSET').length ?? '—',
      '/assets',
    ],
  ];
  return (
    <div className={'governance-home'}>
      <div className={'governance-welcome'}>
        <div>
          <h1>{'你好，欢迎来到管理工作台'}</h1>
          <p>
            {live.auth ? `当前账号：${live.auth.account}` : '登录后读取当前账号有权访问的业务数据'}
          </p>
          <small>本地业务服务 · 持久化数据 · 非生产环境</small>
        </div>
      </div>
      {false}
      <div className={'governance-stats'}>
        {adminCards.map(([label, count, suffix]) => (
          <a
            key={String(label)}
            className={'governance-stat governance-stat-blue'}
            href={link(String(suffix))}
          >
            <div>
              <span>{label}</span>
              <strong>{count}</strong>
              <small>{'当前账号可见审核队列'}</small>
            </div>
          </a>
        ))}
      </div>
      {
        <section className="portal-card governance-recent">
          <h2>当前审核事项</h2>
          <button
            className="portal-button"
            disabled={!live.auth}
            onClick={() => {
              setResult(null);
              setRefresh((value) => value + 1);
            }}
          >
            刷新工作台数据
          </button>
          {result?.session === live.session && result.error && <p role="alert">{result.error}</p>}
          {!live.auth ? (
            <p>请先登录。</p>
          ) : rows === null ? (
            <p>尚未取得有效队列读回。</p>
          ) : (
            <>
              <p>已读取 {rows.length} 条事项。后端未提供按日趋势统计，此处不展示示例曲线。</p>
              <div className="governance-table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>审核编号</th>
                      <th>资料编号</th>
                      <th>类型</th>
                      <th>状态</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => (
                      <tr key={row.caseId}>
                        <td>
                          <a href={link('/queue')}>{row.caseId}</a>
                        </td>
                        <td>{row.submitted.subjectId}</td>
                        <td>
                          {row.submitted.subjectKind === 'LOCAL_ASSET' ? '装备资料' : '产品资料'}
                        </td>
                        <td>{row.decision?.outcome ?? '待处理'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </section>
      }
    </div>
  );
}
